var bell = "https://shopfront-cdn.tekoapis.com/static/c71543de0a174eaf.svg";

export { bell as default };
